export default __webpack_public_path__ + "static/media/deleteTab.63e51dd3.svg";